/**
 * 상세이미지 「영어→한국어 번역」(전체) 버튼이 번역할 사진 목록을 고른다.
 *
 * 작업이 끝난 건은 저장된 상세이미지 목록이 합본 1장(detail_full)뿐이고, 화면의 낱장 사진은
 * 처리된 사진 묶음(processedGroups)에 있다. 그래서 낱장이 있으면 낱장을 기준으로 고른다
 * (PR261017-FC052E: 16장 화면에서 「영어 이미지 1/1」 → 1번 사진이 합본으로 바뀜).
 *
 * @param {Array<Object>} processedGroups - 화면에 보이는 사진 묶음 ({ index, url, isSettingImage, processType })
 * @param {Array<string>} detailImages - 저장된 상세이미지 URL 목록
 * @param {(url: string) => boolean} isTopOrBottom - 상단/하단 설정 이미지 판정
 * @returns {Array<{url: string, index: number}>}
 */
export function englishTranslateTargets(processedGroups, detailImages, isTopOrBottom) {
  const skip = typeof isTopOrBottom === 'function' ? isTopOrBottom : () => false;
  const groups = Array.isArray(processedGroups) ? processedGroups : [];

  if (groups.length > 0) {
    return groups
      .filter(g => g && g.url && !g.isSettingImage && g.processType !== 'setting' && !skip(g.url))
      .map(g => ({ url: g.url, index: g.index }));
  }

  return (Array.isArray(detailImages) ? detailImages : [])
    .map((url, index) => ({ url, index }))
    .filter(t => t.url && !skip(t.url));
}

export default { englishTranslateTargets };
